"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _typography = _interopRequireDefault(require("../typography"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.bds-tooltip-container {\n  border-radius: 0.125rem;\n  width: fit-content;\n  height: fit-content;\n  padding-top: 0.25rem;\n  padding-bottom: 0.375rem;\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n  color: #e0e0e0;\n  background: #393939;\n  box-sizing: border-box; }\n";
  var fileName = "compone_tooltip";
  var element = document.querySelector("style[data-sass-component='compone_tooltip']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})(); // checks if mouse current Position is near the boundary of tooltip
// the boundary is extended by 10 px on all sides tooltip element


var isMousePointerNearTooltipContainer = function isMousePointerNearTooltipContainer(tooltipElement, mouseEvent) {
  var _tooltipElement$getBo = tooltipElement.getBoundingClientRect(),
      tooltipLeft = _tooltipElement$getBo.left,
      tooltipRight = _tooltipElement$getBo.right,
      tooltipBottom = _tooltipElement$getBo.bottom,
      tooltipTop = _tooltipElement$getBo.top;

  var isInsideWidth = false;
  var isInsideHeight = false;

  if (mouseEvent.pageX >= tooltipLeft + window.pageXOffset - _constants.hoverOffset && mouseEvent.pageX < tooltipRight + window.pageXOffset + _constants.hoverOffset) {
    isInsideWidth = true;
  }

  if (mouseEvent.pageY < tooltipBottom + window.pageYOffset + _constants.hoverOffset && mouseEvent.pageY > tooltipTop + window.pageYOffset - _constants.hoverOffset) {
    isInsideHeight = true;
  }

  return isInsideWidth && isInsideHeight;
};

var changeTooltipPos = function changeTooltipPos(tooltipElement, element, position) {
  var rect = element.getBoundingClientRect();
  var absWidthDiff = Math.abs(tooltipElement.offsetWidth - rect.width);
  var absHeightDiff = Math.abs(tooltipElement.offsetHeight - rect.height);
  var vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
  var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

  var moveToTop = function moveToTop() {
    tooltipElement.style.transform = "translate3d(".concat(rect.left + window.pageXOffset - (tooltipElement.offsetWidth >= rect.width ? absWidthDiff / 2 : -1 * (absWidthDiff / 2)), "px,").concat(rect.top + window.pageYOffset - tooltipElement.offsetHeight - _constants.tooltipMargin, "px,0)");
  };

  var moveToBottom = function moveToBottom() {
    tooltipElement.style.transform = "translate3d(".concat(rect.left + window.pageXOffset - (tooltipElement.offsetWidth >= rect.width ? absWidthDiff / 2 : -1 * (absWidthDiff / 2)), "px,").concat(rect.bottom + window.pageYOffset + _constants.tooltipMargin, "px,0)");
  };

  var moveToTopLeft = function moveToTopLeft() {
    tooltipElement.style.transform = "translate3d(".concat(rect.left + window.pageXOffset - _constants.hoverOffset - tooltipElement.offsetWidth, "px,").concat(rect.top + window.pageYOffset - _constants.hoverOffset - tooltipElement.offsetHeight, "px,0)");
  };

  var moveToTopRight = function moveToTopRight() {
    tooltipElement.style.transform = "translate3d(".concat(rect.right + window.pageXOffset + _constants.hoverOffset, "px,").concat(rect.top + window.pageYOffset - _constants.hoverOffset - tooltipElement.offsetHeight, "px,0)");
  };

  var moveToBottomLeft = function moveToBottomLeft() {
    tooltipElement.style.transform = "translate3d(".concat(rect.left + window.pageXOffset - _constants.hoverOffset - tooltipElement.offsetWidth, "px,").concat(rect.bottom + window.pageYOffset + _constants.hoverOffset, "px,0)");
  };

  var moveToBottomRight = function moveToBottomRight() {
    tooltipElement.style.transform = "translate3d(".concat(rect.right + window.pageXOffset + _constants.hoverOffset, "px,").concat(rect.bottom + window.pageYOffset + _constants.hoverOffset, "px,0)");
  };

  var moveToLeft = function moveToLeft() {
    tooltipElement.style.transform = "translate3d(".concat(rect.left + window.pageXOffset - tooltipElement.offsetWidth - _constants.tooltipMargin, "px,").concat(rect.top + window.pageYOffset - (tooltipElement.offsetHeight >= rect.height ? absHeightDiff / 2 : -1 * (absHeightDiff / 2)), "px,0)");
  };

  var moveToRight = function moveToRight() {
    tooltipElement.style.transform = "translate3d(".concat(rect.right + window.pageXOffset + _constants.tooltipMargin, "px,").concat(rect.top + window.pageYOffset - (tooltipElement.offsetHeight >= rect.height ? absHeightDiff / 2 : -1 * (absHeightDiff / 2)), "px,0)");
  };

  var adjustTopPosition = function adjustTopPosition() {
    if (rect.top - tooltipElement.offsetHeight - _constants.tooltipMargin < 0) {
      moveToBottom();
    } else {
      moveToTop();
    }
  };

  var adjustBottomPosition = function adjustBottomPosition() {
    if (rect.bottom + tooltipElement.offsetHeight + _constants.tooltipMargin > vh) {
      moveToTop();
    } else {
      moveToBottom();
    }
  };

  var adjustLeftPosition = function adjustLeftPosition() {
    if (rect.left - tooltipElement.offsetWidth - _constants.tooltipMargin < 0) {
      moveToRight();
    } else {
      moveToLeft();
    }
  };

  var adjustRightPosition = function adjustRightPosition() {
    if (rect.right + _constants.tooltipMargin + tooltipElement.offsetWidth > vw) {
      moveToLeft();
    } else {
      moveToRight();
    }
  };

  var adjustTopLeftPosition = function adjustTopLeftPosition() {
    if (rect.top - tooltipElement.offsetHeight - _constants.tooltipMargin < 0) {
      moveToBottomLeft();
    } else if (rect.left - tooltipElement.offsetWidth - _constants.tooltipMargin < 0) {
      moveToTopRight();
    } else {
      moveToTopLeft();
    }
  };

  var adjustTopRightPosition = function adjustTopRightPosition() {
    if (rect.top - tooltipElement.offsetHeight - _constants.tooltipMargin < 0) {
      moveToBottomRight();
    } else if (rect.right + _constants.tooltipMargin + tooltipElement.offsetWidth > vw) {
      moveToTopLeft();
    } else {
      moveToTopRight();
    }
  };

  var adjustBottomLeftPosition = function adjustBottomLeftPosition() {
    if (rect.bottom + tooltipElement.offsetHeight + _constants.tooltipMargin > vh) {
      moveToTopLeft();
    } else if (rect.left - tooltipElement.offsetWidth - _constants.tooltipMargin < 0) {
      moveToBottomRight();
    } else {
      moveToBottomLeft();
    }
  };

  var adjustBottomRightPosition = function adjustBottomRightPosition() {
    if (rect.bottom + tooltipElement.offsetHeight + _constants.tooltipMargin > vh) {
      moveToTopRight();
    } else if (rect.right + _constants.tooltipMargin + tooltipElement.offsetWidth > vw) {
      moveToBottomLeft();
    } else {
      moveToBottomRight();
    }
  };

  switch (position) {
    case 'top':
      adjustTopPosition();
      break;

    case 'bottom':
      adjustBottomPosition();
      break;

    case 'left':
      adjustLeftPosition();
      break;

    case 'right':
      adjustRightPosition();
      break;

    case 'top-left':
      adjustTopLeftPosition();
      break;

    case 'top-right':
      adjustTopRightPosition();
      break;

    case 'bottom-left':
      adjustBottomLeftPosition();
      break;

    case 'bottom-right':
      adjustBottomRightPosition();
      break;
  }
};

var Tooltip = function Tooltip(_ref) {
  var title = _ref.title,
      children = _ref.children,
      position = _ref.position,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? _constants.zIndexDefault : _ref$zIndex,
      className = _ref.className;

  var _useState = (0, _react.useState)(document.createElement('div')),
      _useState2 = _slicedToArray(_useState, 1),
      tooltipElement = _useState2[0];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isHover = _useState4[0],
      setIsHover = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isNear = _useState6[0],
      setIsNear = _useState6[1];

  var childRef = (0, _react.useRef)();
  tooltipElement.id = "".concat(_constants.tooltipId);
  tooltipElement.style.position = 'absolute';
  tooltipElement.style.willChange = 'transform';
  tooltipElement.style.zIndex = zIndex;
  tooltipElement.style.top = 0;
  tooltipElement.style.left = 0;
  tooltipElement.style.maxWidth = _constants.tooltipMaxWidth;
  tooltipElement.style.maxHeight = _constants.tooltipMaxHeight;
  tooltipElement.style.overflow = 'auto';

  if (className) {
    tooltipElement.classList.add(className);
  }

  (0, _react.useEffect)(function () {
    document.body.appendChild(tooltipElement);

    var mouseMoveHandler = function mouseMoveHandler(event) {
      var isMousePointerNear = isMousePointerNearTooltipContainer(tooltipElement, event);

      if (isMousePointerNear) {
        setIsNear(true);
      } else {
        setIsNear(false);
      }
    };

    document.addEventListener('mousemove', mouseMoveHandler);
    return function () {
      document.body.removeChild(tooltipElement);
      document.removeEventListener('mousemove', mouseMoveHandler);
    };
  }, []);
  (0, _react.useLayoutEffect)(function () {
    if (childRef && childRef.current && isHover) {
      changeTooltipPos(tooltipElement, childRef.current, position);
    }
  }, [isHover, title]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/(0, _react.cloneElement)(_react.default.Children.only(children), {
    ref: childRef,
    onMouseOver: function onMouseOver(e) {
      setIsHover(true);
    },
    onMouseLeave: function onMouseLeave(e) {
      setIsHover(false);
    }
  }), (isHover || isNear) && title && /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.tooltipContainer,
    onMouseLeave: function onMouseLeave() {
      return setIsNear(false);
    }
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "body"
  }, title, " ")), tooltipElement));
};

var _default = Tooltip;
exports.default = _default;